/**
 * Module definition houses all application components
 *
 * @module components
 */
angular.module('components', [
  'components.editor',
  'components.media',
  'components.SessionTimer'
])

/**
 * The components provides a view listing all components
 *
 * @class components
 * @constructor
 * @module components
 * @example
 *   <components
 *     model="form.model">
 *   </components>
 */
.directive('components', [
  function () {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        stateId: '=',
        model: '='
      },
      templateUrl: function () {
        return 'components/components.html';
      }
    };
  }
]);
